var map = {
	"./assembleias.svg": 4786,
	"./comunicados.svg": 6979,
	"./entrar.svg": 396,
	"./fechar.svg": 5849,
	"./fundos.svg": 628,
	"./sair.svg": 5022,
	"./templates.svg": 2701,
	"./usuarios.svg": 1428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2223;